module.exports = __webpack_public_path__ + "img/privilege1.b4d567e2.png";